<template>
  <div class="container course-create">
    <div class="header">
      <el-breadcrumb class="breadcrumb" separator="/">
        <el-breadcrumb-item>运营管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/college/menu/list' }">院校菜单</el-breadcrumb-item>
        <el-breadcrumb-item>菜单编辑</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
        </div>
        <div class="right">
          <el-button plain @click="handleClose">取消</el-button>
          <el-button type="primary" @click="handleSubmit">保存</el-button>
        </div>
      </div>
    </div>
    <div class="main">
      <h3 class="title">菜单编辑</h3>
      <div class="content">
        <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="130px" class="dataForm">
         <el-form-item label="菜单标题" prop="title">
          <el-input v-model="dataForm.title" placeholder="请输入菜单标题"></el-input>
        </el-form-item>
        <el-form-item label="副标题" prop="subtitle">
          <el-input v-model="dataForm.subtitle" placeholder="请输入菜单副标题"></el-input>
        </el-form-item>
        <el-form-item label="跳转链接" prop="link_url">
          <el-input v-model="dataForm.link_url" placeholder="请输入跳转链接"></el-input>
        </el-form-item>
        <el-form-item label="菜单图标" prop="icon">
          <el-upload
            class="cover-uploader"
            :action="imgUploadUrl"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :before-upload="handleBeforeUpload">
            <img v-if="dataForm.icon" :src="dataForm.icon" class="cover">
            <i v-else class="el-icon-plus cover-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="排序值" prop="sort">
          <el-input v-model="dataForm.sort" placeholder="请输入排序值，纯数字"></el-input>
        </el-form-item>
        <el-form-item label="客户端" prop="client_ids">
          <el-select v-model="dataForm.client_ids" multiple placeholder="请选择客户端" style="width: 100%;">
            <el-option
              v-for="item in clients"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开放状态" prop="open_status">
          <el-switch v-model="dataForm.open_status"></el-switch>
        </el-form-item>
        <el-form-item label="在线状态" prop="status">
          <el-switch v-model="dataForm.status"></el-switch>
        </el-form-item>
        <el-form-item label="适合专业：" prop="majors">
          <div class="tag-wrap">
            <el-tag
              class="subject-item"
              size="medium"
              :key="item.id"
              v-for="item in majors"
              closable
              :disable-transitions="false"
              @close="handleMajorRemove(item)">
              {{`${item.name}/${item.code}`}}
            </el-tag>
            <el-button type="text" @click="handleMajorChoose">选择专业</el-button>
          </div>
        </el-form-item>
        <el-form-item label="适合院校：" prop="colleges">
          <div class="tag-wrap">
            <el-tag
              class="subject-item"
              size="medium"
              :key="item.id"
              v-for="item in colleges"
              closable
              :disable-transitions="false"
              @close="handleCollegeRemove(item)">
              {{`${item.name}`}}
            </el-tag>
            <el-button type="text" @click="handleCollegeChoose">选择院校</el-button>
          </div>
        </el-form-item>
        </el-form>
      </div>

    </div>
    <MajorChoose :visible="majorChooseDialog" :majors="majors" @close="majorChooseDialog = false" @submit="saveMajor"></MajorChoose>
    <CollegeChoose :visible="collegeChooseDialog" :colleges="colleges" @close="collegeChooseDialog = false" @submit="saveCollege"></CollegeChoose>
  </div>
</template>

<script>
import MajorChoose from '@/components/dialog/major/MajorChoose'
import CollegeChoose from '@/components/dialog/college/CollegeChoose'
import { imgUploadUrl, uploadHeaders } from '@/config/index'
import { collegeMenuOne, collegeMenuUpdate } from '@/api/common'
import { clientList } from '@/api/operation'

export default {
  components: {
    MajorChoose,
    CollegeChoose
  },
  data() {
    return {
      majorChooseDialog: false,
      collegeChooseDialog: false,
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      dataForm: {
        icon: ''
      },
      majors: [],
      colleges: [],
      clients: [],
      rules: {
        title: [{ required: true, message: '请输入菜单标题', trigger: 'blur' }],
        subtitle: [{ required: false, message: '请输入菜单副标题', trigger: 'blur' }],
        link_url: [{ required: true, message: '请输入跳转链接', trigger: 'blur' }],
        icon: [{ required: true, message: '请上传菜单图标', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序值，纯数字', trigger: 'blur' }],
        open_status: [{ required: false, message: '请设置开放状态', trigger: 'change' }],
        status: [{ required: false, message: '请设置上线状态', trigger: 'change' }]
      }
    }
  },
  created() {
    this.fetchClientList()
    this.fetchCollegeMenuInfo()
  },
  mounted() {
    this.scrollToTop()
  },
  methods: {
    fetchClientList() {
      clientList({isPaging: 0}).then(res => {
        this.clients = res.list
      })
    },
    // 菜单基本信息
    fetchCollegeMenuInfo() {
      collegeMenuOne({id: this.$route.params.menuId}).then(res => {
        if (res) {
          res.status = res.status === 1 ? true : false
          res.open_status = res.open_status === 1 ? true : false
          this.colleges = res.colleges || this.colleges
          this.majors = res.majors || this.majors

          if (res.client_ids) {
            res.client_ids = res.client_ids.split(',').map(v => Number(v))
          }

          this.dataForm = res
        }
      })
    },
    scrollToTop() {
      // Chrome
      document.body.scrollTop = 0
      // Firefox
      document.documentElement.scrollTop = 0
      // Safari
      window.pageYOffset = 0
    },
    handleMajorRemove(item) {
      this.majors = this.majors.filter(v => v.id !== item.id)
    },
    handleMajorChoose() {
      this.majorChooseDialog = true
    },
    saveMajor({majors}) {
      this.majors = majors
    },
    handleCollegeRemove(item) {
      this.colleges = this.colleges.filter(v => v.id !== item.id)
    },
    handleCollegeChoose() {
      this.collegeChooseDialog = true
    },
    saveCollege({colleges}) {
      this.colleges = colleges
    },
    handleUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.dataForm.icon = res.data.url
      } else {
        this.$message.error(res.error)
      }
    },
    handleUploadQrcodeSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.dataForm.qrcode = res.data.url
      } else {
        this.$message.error(res.error)
      }
    },
    handleBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.dataForm, {
            status: this.dataForm.status ? 1 : 0,
            open_status: this.dataForm.open_status ? 1 : 0,
            majors: this.majors.map(item => ({code: item.code, college_code: item.college_code})),
            colleges: this.colleges.map(item => ({code: item.code})),
          })
          collegeMenuUpdate(params).then(res => {
            this.$message.success(`编辑成功`)
            this.$refs['dataForm'].resetFields()

            this.$router.go(-1)
          }).catch(error => {
            console.log('error: ', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
.course-create {
  .header {
    background: #fff;
    padding: 20px;

    .breadcrumb {
      margin-bottom: 20px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .main {
    background: #fff;
    padding: 20px;
    margin-top: 10px;

    .title {
      font-size: 32px;
      font-weight: bold;
    }
  }
  .content {
    display: flex;
    margin-top: 20px;

    .dataForm {
      min-width: 700px;
      // width: 100%;
    }

    .button {
      font-size: 14px;
      padding: 12px 20px;
      margin-bottom: 10px;

      &.small {
        padding: 9px 15px;
      }
    }
    .cover-uploader /deep/ .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .cover-uploader /deep/ .el-upload:hover {
      border-color: #409EFF;
    }
    .cover-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 128px;
      height: 128px;
      line-height: 128px;
      text-align: center;
    }
    .cover {
      display: block;
      width: 128px;
      height: 128px;
      object-fit: cover;
    }
    .tag-wrap {
      display: flex;
      flex-wrap: wrap;
    }
    .subject-item,
    .teacher-item {
      margin-right: 5px;
      margin-bottom: 5px;
    }
  }
  .form-header {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    background: #f8f8f8;
    margin-bottom: 20px;

    .form-header-inner {
      padding: 10px;
    }
  }
}
</style>
